import '@shoelace-style/shoelace/dist/components/spinner/spinner.js';
import '@shoelace-style/shoelace/dist/components/progress-ring/progress-ring.js';

import { css, unsafeCSS } from 'lit';
import {mobileBreakPoint} from '../../styles/sizes';
import {unsafeCSSIcon} from "../../styles/icons";

// language=CSS
export const styles =
    css`
        :host {
            --sp-spot-transfer-indicator-badge-size: calc(var(--sp-spot-transfer-indicator-size) / 2.5);
            --sp-spot-transfer-indicator-spinner-track-width: calc(var(--sp-spot-transfer-indicator-badge-size) / 8);
            --sp-spot-transfer-indicator-spinner-size: calc(var(--sp-spot-transfer-indicator-badge-size) - 2 * var(--sp-spot-transfer-indicator-spinner-track-width));
            --sp-spot-transfer-indicator-background-size: calc(var(--sp-spot-transfer-indicator-size) - 2 * var(--sp-spot-transfer-indicator-track-width) + 4px);
            --sp-spot-transfer-indicator-background-offset: calc(var(--sp-spot-transfer-indicator-track-width) - 2px);
            --sl-color-primary-600: rgb(var(--sp-greydark));
        }
        
        .container {
            position: relative;
            width: var(--sp-spot-transfer-indicator-size);
            height: var(--sp-spot-transfer-indicator-size);
            cursor: pointer;
        }
        
        .bg {
            position: absolute;
            width: var(--sp-spot-transfer-indicator-background-size);
            height: var(--sp-spot-transfer-indicator-background-size);
            top: var(--sp-spot-transfer-indicator-background-offset);
            left: var(--sp-spot-transfer-indicator-background-offset);
            border-radius: 50%;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            z-index: 1;
        }
        
        sl-spinner {
            position: absolute;
            top: var(--sp-spot-transfer-indicator-spinner-track-width);
            left: var(--sp-spot-transfer-indicator-spinner-track-width);
            z-index: 2;
            font-size: var(--sp-spot-transfer-indicator-spinner-size);
            --track-width: var(--sp-spot-transfer-indicator-spinner-track-width);
            --track-color: transparent;
            --indicator-color: rgb(var(--sp-color-c));
        }
        
        sl-progress-ring {
            position: absolute;
            top: 0;
            left: 0;
            z-index: 2;
            --size: var(--sp-spot-transfer-indicator-size);
            --track-width: var(--sp-spot-transfer-indicator-track-width);
        }
        
        sl-badge {
            position: absolute;
            top: 0;
            right: 0;
            z-index: 3;
        }

        .text-container {
            font-size: calc(var(--sp-spot-transfer-indicator-badge-size) / 2.8);
            font-weight: bold;
        }
        
        .smaller {
            font-size: calc(var(--sp-spot-transfer-indicator-badge-size) / 3.5);
            font-weight: normal;
            padding-left: 1px;
        }
        
        sl-badge::part(base) {
            height: var(--sp-spot-transfer-indicator-badge-size);
            width: var(--sp-spot-transfer-indicator-badge-size);
            border: 0;
            padding: 0;
        }
        
        .icon {
            width: calc(var(--sp-spot-transfer-indicator-spinner-size) - var(--sp-spot-transfer-indicator-spinner-track-width) * 2);
            aspect-ratio: 1;
            background-repeat: no-repeat;
            background-size: contain;
        }

        /* This is a legacy browser fallback */
        @supports not (aspect-ratio: 1) {
            .icon {
                height: calc(var(--sp-spot-transfer-indicator-spinner-size) - var(--sp-spot-transfer-indicator-spinner-track-width) * 2);
            }
        }
        
        .error {
            background-image: url(${ unsafeCSSIcon('alert', { size: 'x128' }) });
        }
        
        .finished {
            background-image: url(${ unsafeCSSIcon('check', { size: 'x128' }) });
        }
        
        .pause {
            background-image: url(${ unsafeCSSIcon('pause') });
        }
        
        @media (max-width: ${ unsafeCSS(mobileBreakPoint) }) {
            sl-badge {
                right: unset;
                left: 0;
            }
        }
    `;
